import { CompetitionsUsersBase } from "./competitions-users-base";

export default function CompetitionsInvitedUser() {
  return (
    <div>
      <CompetitionsUsersBase />
    </div>
  );
}
